export const peopleModal = () => {
	const people = document.querySelectorAll('.wp-block-people-a__people .person');
	//exit if no people
	if (people.length === 0) {
		return;
	}

	// Separate popup and single-page people
	const popupPeople = Array.from(people).filter(p => p.dataset.linkMode !== 'single');
	const singlePeople = Array.from(people).filter(p => p.dataset.linkMode === 'single');

	// Initialize popup functionality only if there are popup-mode people
	if (popupPeople.length > 0) {
		initializePopupMode(popupPeople);
	}

	// Initialize single-page mode for single-page people
	if (singlePeople.length > 0) {
		initializeSinglePageMode(singlePeople);
	}
};

const initializePopupMode = (people) => {
	const popupOverlay = document.querySelector('.popup-overlay');
	const contentContainer = popupOverlay.querySelector('.content-container');
	const closeButton = popupOverlay.querySelector('.close-btn');
	const prevButton = popupOverlay.querySelector('.prev-btn');
	const nextButton = popupOverlay.querySelector('.next-btn');

	let lastFocusedElement;
	let currentIndex = 0; // Global current index

	const showPopup = (index) => {
		currentIndex = index;
		lastFocusedElement = document.activeElement;

		const personContent = people[currentIndex].querySelector('.person-content');
		contentContainer.innerHTML = personContent.innerHTML;

		document.body.classList.add('popup-open');
		popupOverlay.setAttribute('aria-hidden', 'false');
		popupOverlay.setAttribute('aria-label', people[currentIndex].querySelector('.person-name').innerText);
		contentContainer.focus();
		popupOverlay.scrollTop = 0;
	};

	const closePopup = () => {
		popupOverlay.setAttribute('aria-hidden', 'true');
		lastFocusedElement.focus();
		document.body.classList.remove('popup-open');
	};

	closeButton.addEventListener('click', closePopup);

	prevButton.addEventListener('click', (event) => {
		event.stopPropagation(); // Stop event propagation
		showPopup((currentIndex - 1 + people.length) % people.length);
	});

	nextButton.addEventListener('click', (event) => {
		event.stopPropagation(); // Stop event propagation
		showPopup((currentIndex + 1) % people.length);
	});

	popupOverlay.addEventListener('click', (event) => {
		if (event.target === popupOverlay) {
			closePopup();
		}
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			closePopup();
		}
	});

	people.forEach((person, index) => {
		person.setAttribute('role', 'button');
		person.setAttribute('aria-haspopup', 'dialog');
		person.addEventListener('click', (event) => {
			event.preventDefault();
			showPopup(index);
		});
	});
};

const initializeSinglePageMode = (people) => {
	people.forEach((person) => {
		const url = person.dataset.personUrl;
		if (url) {
			person.style.cursor = 'pointer';
			person.setAttribute('role', 'button');
			person.setAttribute('tabindex', '0');
			
			// Navigate to single page on click
			person.addEventListener('click', (event) => {
				event.preventDefault();
				window.location.href = url;
			});
			
			// Also handle Enter key for accessibility
			person.addEventListener('keypress', (event) => {
				if (event.key === 'Enter' || event.keyCode === 13) {
					event.preventDefault();
					window.location.href = url;
				}
			});
		}
	});
};
